import ReactGA from 'react-ga'
import ReactPixel from 'react-facebook-pixel'
import { environmentIndex } from 'env'

export const initAnalytics = () => {
    ReactGA.initialize('UA-123761606-1')
    ReactPixel.init('2324025884585559', null, {
        autoConfig: true,
        debug: true
    })

    ReactPixel.pageView()
}

export const logAnalyticsEvent = props => {
    if (environmentIndex === 1) {
        ReactGA.event(props)
    }
}

export const logPixelEvent = props => {
    if (environmentIndex === 1) {
        ReactPixel.track(props)
    }
}


// WEBPACK FOOTER //
// ./src/utils/analytics.js